module.exports = __webpack_public_path__ + "img/pennellata-top.45b8fbdd.jpg";